import { UseQueryResult } from "@tanstack/react-query";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { SomethingUnexpectedHappenedMessageBox } from "components/MessageBox/SomethingUnexpectedHappenedMessageBox";
import { Loading } from "components/panels";
import React from "react";

interface Props {
  productsApi?: UseQueryResult<server.dto.ProductsByParent, unknown>
  products?: server.dto.Product[]
  selectedProducts: number[]
  setSelectedProducts: React.Dispatch<React.SetStateAction<number[]>>
}

export const ProductCheckboxList = (props: Props) => {
  if (props.productsApi?.isFetching) return <div className="main-section-template-fields-padding">
    <Loading />
  </div>

  if (props.productsApi?.isError) return <div className="main-section-template-fields-padding">
    <SomethingUnexpectedHappenedMessageBox />
  </div>

  if (props.productsApi?.data?.collection.length === 0) return <div className="main-section-template-fields-padding main-section-template-fields-empty">
    {RESX.Advancing.NoValue}
  </div>

  const selectedProductsMap = new Set<number>(props.selectedProducts);

  const products = props.productsApi?.data?.collection ?? props.products;

  return <div
    className="main-section-template-fields-padding gap-small"
    style={{
      display: "grid",
      gridTemplateColumns: "1fr auto",
      paddingLeft: 0
    }}>
    {products.map(product => (
      <React.Fragment key={product.productId}>
        <div>
          <Checkbox
            label={product.title}
            checked={selectedProductsMap.has(product.productId)}
            onChange={() => props.setSelectedProducts(old => {
              if (selectedProductsMap.has(product.productId)) {
                return old.filter(id => id !== product.productId);
              } else {
                return [...old, product.productId];
              }
            })}
          />
        </div>
        <div style={{ textAlign: "right" }}>
          {product.sales?.totalExVat.formatted}
        </div>
      </React.Fragment>
    ))}
  </div>

}